(function() {
  'use strict';
  angular.module('dso')
  .controller('dsoLookupController',['$scope', 'Dso', '$filter', '$uibModal', '$log', 'UpdateDsoEmail', 'uiGridConstants', 'dsoRegistrationService',
    function($scope, Dso, $filter, $uibModal, $log, UpdateDsoEmail, uiGridConstants, dsoRegistrationService) {
    var vm = this;
    vm.model = { };
    vm.dsoProfiles = [];
    vm.filteredDSOProfiles = [];
    vm.submit = submit;
    vm.dsoNames = [];
    vm.running = false;
    vm.showGrid = true;
    vm.reset = () => { vm.model = {}; vm.submit();};
    vm.dsosLookupGridOptions = {
      enableSorting: true,
      enableColumnResizing: true,
      enableRowSelection: true,
      enableFullRowSelection: true,
      enableRowHeaderSelection: false,
      multiSelect: false,
      exporterMenuPdf: false,
      noUnselect: true,
      modifierKeysToMultiSelect: true,
      enableGridMenu: true,
      columnDefs: [
        { field: 'addDsoMode', visible: false, sort: {direction: uiGridConstants.ASC, priority: 0},
          suppressRemoveSort: true, sortDirectionCycle: [uiGridConstants.ASC]
        },
        { field: 'name', displayName: 'DSO Name'},
        { field: 'getContactName()', displayName: 'Contact Name' },
        { field: 'email'},
        { field: 'getPhone()', displayName:'Phone'},
        { field: 'taxIdCount', displayName: 'Tax ID Count'},
        { field: 'getStatus()', displayName: 'Status'}
      ],
      rowTemplate: rowTemplate(),

      appScopeProvider: {
        showModal : (row) => {
          vm.gridApi.selection.selectRow(row);
          openModal(row);
        }
      },
      onRegisterApi: function(api) {
        vm.gridApi = api;
      }
    };

    function rowTemplate() {
      return '<div ng-if="row.entity.addDsoMode" ng-dblclick="grid.appScope.showModal(row)"><i>'+
      '<b>Double Click to Register DSO...</b></i></div>' +
      '<div ng-if="!row.entity.addDsoMode" ng-dblclick="grid.appScope.showModal(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name"'  +
      'class="ui-grid-cell" ng-class="{\'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell></div>';
    }

    var runGridQuery = function(criteria){
      vm.running = true;
      let firstRow = { addDsoMode: true};
      Dso.query(criteria, (res) => {
        vm.running = false;
        if(!criteria){
          vm.dsoNames = _.map(res, (dso) => dso.name );
        }
        if(res.length){
          res.splice(0,0, firstRow);
          vm.dsosLookupGridOptions.data = res;
        }else{
          vm.dsosLookupGridOptions.data = [firstRow];
        }
      }, () => {
        vm.running = false;
      });
    };

    runGridQuery(null);

    function submit() {
      let criteria = _.mapValues(vm.model, (value, name) => {
        if (value) {
            return value.split('*').join('%');
        }
      });
      criteria.taxId && (criteria.taxId = criteria.taxId.split('-').join(''));
      runGridQuery(criteria);
    }
    var formatTaxIdsForRegistration = function(dso){
        let taxIds = [];
        _.each(dso.taxIds,(taxId) => {
          taxIds.push({'taxId': taxId.taxId});
        });
        dso.taxIds = taxIds;
    };

    var saveDso = function(dso){
      if(dso.id > 0){
        Dso.update(dso, function(response) {
          vm.submit();
          $scope.dnConfirmationMessage.$show("DSO profile updated successfully.");
        });
      } else {
        formatTaxIdsForRegistration(dso);
        dsoRegistrationService.dsoRegistrationModel(dso);
        let dsoProfile = angular.copy(dsoRegistrationService.dsoProfile());
        vm.running = true;
        Dso.save(dsoProfile, function(response) {
          vm.running = false;
          response.taxIdCount = dso.taxIds.length;
          vm.dsosLookupGridOptions.data.push(response);
          vm.dsoNames = _.map(vm.dsosLookupGridOptions.data, (d) => d.name );
          $scope.dnConfirmationMessage.$show("DSO "+response.name+" has been successfully registered.");
        }, () => {
          vm.running = false;
        });
      }
    };

    function openModal(row) {
      var modalResult = $uibModal.open({
        controllerAs: 'vm',
        controller: 'editDsoController',
        templateUrl: '/js/dso/editDsoModal.html' + appVersion,
        animation: false,
        resolve: {
          row: () => !row.entity.addDsoMode ? Dso.get({id: row.entity.id}).$promise : {id: 0, taxIds: [], addDsoMode: true},
        },
        size: 'lg'
      });
      modalResult.result.then(function(result) {
          switch (result.action)  {
            case 'saveDso':
              saveDso(result.dso);
              break;
            case 'approveDso' :
              Dso.approve(result.dso, function(data) {
                $scope.dnConfirmationMessage.$show("Registration Invite has been sent to " + result.dso.name);
                vm.submit();
              });
              break;
            case 'updateEmail' :
              UpdateDsoEmail(result.dso.registrationRequestGuid).update(result.dso,function(data) {
                Dso.sendRegistrationInvite({id: result.dso.id}, function(data) {
                  $scope.dnConfirmationMessage.$show("Registration invite has been resent to " + data.email);
                  vm.submit();
                });
              });
              break;
            case 'deleteDso':
              Dso.delete({id: result.dso.id}, function() {
                vm.submit();
                $scope.dnConfirmationMessage.$show('DSO ' + result.dso.name + ' has been deleted.', 'danger');
              });
              break;
            case 'updateDsoProfile':
              vm.submit();
              break;
          }
      },angular.noop);
    }
    vm.validate = function () {
      Dso.validateTaxIds().$promise.then(() => {
        $scope.dnConfirmationMessage.$show("Tax ID Validation Process Running");
      });
    };
  }]);
})();
